import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { AuthGuard } from "@/src/auth/components/auth-guard";
import { useAuth } from "@/src/auth/hooks/use-auth";
import { MARKETING_ROUTES } from "@/src/marketing/constants/marketing-routes";

function RequireSuperAdmin({ children }: { children: ReactNode }) {
	const { user, isLoading } = useAuth();
	if (isLoading) return null;
	if (!user?.is_super_admin) return <Navigate to={MARKETING_ROUTES.HOME} replace />;
	return <>{children}</>;
}

export function SuperAdminGuard({ children }: { children: ReactNode }) {
	return (
		<AuthGuard>
			<RequireSuperAdmin>{children}</RequireSuperAdmin>
		</AuthGuard>
	);
}
